import IO from '../_classes/IO';

function setAnimation ($containers) {
	const animateIO = new IO();
	animateIO.setBefore(function (container, observer) {
		const $container = $(container);
		const innerElements = $container.find('[data-animate-element]');
		const $elements = innerElements.length ? innerElements : $container;
		const delay = $container.data('animate-delay');

		if (!$container.data('is-init')) {
			$elements.each(function (i, el) {
				const $element = $(this);
				if (i > 0 && delay) {
					$element.addClass('_animate-delay-' + i);
				}
				$element.addClass('animated');
			});

			$container.data({
				'is-animated': false,
				'is-init': true
			});

			observer.observe(container);
		}
	});
	animateIO.setCallback(function (entry) {
		const $container = $(entry.target);
		const innerElements = $container.find('[data-animate-element]');
		const $elements = innerElements.length ? innerElements : $container;
		const alias = $container.data('animate');
		const isRepeat = !!$container.data('animate-repeat');

		if (!isRepeat) {
			if (entry.isIntersecting && !$container.data('is-animated')) {
				$elements.each(function (i, el) {
					const $element = $(this);
					$element.addClass(alias);
				});
				$container.data('is-animated', true);
			}
		} else {
			if (entry.isIntersecting) {
				$elements.each(function (i, el) {
					const $element = $(this);
					$element.addClass(alias);
				});
				$container.data('is-animated', true);
			} else {
				$elements.each(function (i, el) {
					const $element = $(this);
					$element.removeClass(alias);
				});
				$container.data('is-animated', false);
			}
		}
	});
	animateIO.observe($containers);
}

function removeAnimation ($containers) {
	$containers.each((index, container) => {
		const $container = $(container);
		const innerElements = $container.find('[data-animate-element]');
		const $elements = innerElements.length ? innerElements : $container;
		const alias = $container.data('animate');

		$elements.each(function (i, el) {
			const $element = $(el);
			$element.removeClass('animated');
			$element.removeClass(alias);
		});
	});
}

export default function ($container = $('body')) {
	const $elements = $container.find('[data-animate]');
	const $elementsResponsive = $elements.filter((index, element) => $(element).data('animate-responsive'));
	const $elementsNotResponsive = $elements.filter((index, element) => !$(element).data('animate-responsive'));
	const responsiveWidth = 768;

	if ($elementsNotResponsive.length && $(window).width() > responsiveWidth) {
		setAnimation($elementsNotResponsive);
	} else {
		removeAnimation($elementsNotResponsive);
	}

	if ($elementsResponsive.length) {
		setAnimation($elementsResponsive);
	}
}



// WEBPACK FOOTER //
// ./src/js/_modules/animate.js